import React from "react";
import { Reveal } from "@/components/Reveal";
import { useBooking } from "@/lib/booking-context";
import { EXPERIENCES } from "@/data/content";

export const Experiences = () => {
  const { openBooking } = useBooking();
  return (
    <section id="experiences" className="pt-16 md:pt-20 pb-28 md:pb-40 bg-warmwhite" data-testid="experiences-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="max-w-3xl mb-16 md:mb-24">
          <Reveal>
            <p className="overline text-champagne mb-6">Our Cleaning Experiences</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.08] text-charcoal">
              Curated care for exceptional homes.
            </h2>
          </Reveal>
        </div>

        {/* First: large feature row */}
        <div className="grid lg:grid-cols-2 gap-6 md:gap-8">
          {EXPERIENCES.slice(0, 2).map((e, i) => (
            <Reveal key={e.title} delay={i * 0.1}>
              <div className="group cursor-pointer" onClick={openBooking} data-testid={`experience-${i}`}>
                <div className="img-frame">
                  <img src={e.image} alt={e.title} className="w-full aspect-[16/11] object-cover" />
                </div>
                <div className="pt-6 flex items-start justify-between gap-6">
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-charcoal font-normal">{e.title}</h3>
                    <p className="mt-3 text-charcoal/60 leading-relaxed max-w-md text-[15px]">{e.body}</p>
                  </div>
                  <span className="font-serif text-stone text-2xl mt-1 shrink-0 group-hover:text-champagne transition-colors">→</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Then: three column row */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mt-6 md:mt-8">
          {EXPERIENCES.slice(2).map((e, i) => (
            <Reveal key={e.title} delay={i * 0.1}>
              <div className="group cursor-pointer" onClick={openBooking} data-testid={`experience-${i + 2}`}>
                <div className="img-frame">
                  <img src={e.image} alt={e.title} className="w-full aspect-[4/5] object-cover" />
                </div>
                <div className="pt-6">
                  <h3 className="font-serif text-xl md:text-2xl text-charcoal font-normal">{e.title}</h3>
                  <p className="mt-3 text-charcoal/60 leading-relaxed text-[15px]">{e.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
